module.exports = __webpack_public_path__ + "img/docx_icon.0e167cc0.png";